(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7118"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7118"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e93Ww", function(module, exports) {

var $2dbSv = parcelRequire("2dbSv");
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const _variant = urlParams.get("variant");
if (window.location.pathname.includes("/products/") && document.querySelector(".embla-pdp__viewport")) {
    const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb)=>{
        const slidesThumbs = emblaApiThumb.slideNodes();
        const scrollToIndex = slidesThumbs.map((_, index)=>()=>emblaApiMain.scrollTo(index));
        slidesThumbs.forEach((slideNode, index)=>{
            slideNode.addEventListener("click", scrollToIndex[index], false);
        });
        return ()=>{
            slidesThumbs.forEach((slideNode, index)=>{
                slideNode.removeEventListener("click", scrollToIndex[index], false);
            });
        };
    };
    const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb)=>{
        const slidesThumbs = emblaApiThumb.slideNodes();
        const toggleThumbBtnsState = ()=>{
            emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
            const previous = emblaApiMain.previousScrollSnap();
            const selected = emblaApiMain.selectedScrollSnap();
            slidesThumbs[previous].classList.remove("embla-thumbs__slide--selected");
            slidesThumbs[selected].classList.add("embla-thumbs__slide--selected");
        };
        emblaApiMain.on("select", toggleThumbBtnsState);
        emblaApiThumb.on("init", toggleThumbBtnsState);
        return ()=>{
            const selected = emblaApiMain.selectedScrollSnap();
            slidesThumbs[selected].classList.remove("embla-thumbs__slide--selected");
        };
    };
    const addTogglePrevNextBtnsActive = (emblaApiMain, prevBtn, nextBtn)=>{
        const togglePrevNextBtnsState = ()=>{
            if (emblaApiMain.canScrollPrev()) prevBtn.removeAttribute("disabled");
            else prevBtn.setAttribute("disabled", "disabled");
            if (emblaApiMain.canScrollNext()) nextBtn.removeAttribute("disabled");
            else nextBtn.setAttribute("disabled", "disabled");
        };
        emblaApiMain.on("select", togglePrevNextBtnsState).on("init", togglePrevNextBtnsState).on("reInit", togglePrevNextBtnsState);
        return ()=>{
            prevBtn.removeAttribute("disabled");
            nextBtn.removeAttribute("disabled");
        };
    };
    const addPrevNextBtnsClickHandlers = (emblaApiMain, prevBtn, nextBtn)=>{
        const scrollPrev = ()=>emblaApiMain.scrollPrev();
        const scrollNext = ()=>emblaApiMain.scrollNext();
        prevBtn.addEventListener("click", scrollPrev, false);
        nextBtn.addEventListener("click", scrollNext, false);
        const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(emblaApiMain, prevBtn, nextBtn);
        return ()=>{
            removeTogglePrevNextBtnsActive();
            prevBtn.removeEventListener("click", scrollPrev, false);
            nextBtn.removeEventListener("click", scrollNext, false);
        };
    };
    const OPTIONS = {
        loop: true
    };
    const OPTIONS_THUMBS = {
        containScroll: "keepSnaps",
        dragFree: true
    };
    const emblaNode = document.querySelector(".product-main-swiper");
    const viewportNodeMainCarousel = document.querySelector(".embla-pdp__viewport");
    const viewportNodeThumbCarousel = document.querySelector(".embla-thumbs__viewport");
    const emblaApiMain = (0, $2dbSv.default)(viewportNodeMainCarousel, OPTIONS);
    const emblaApiThumb = (0, $2dbSv.default)(viewportNodeThumbCarousel, OPTIONS_THUMBS);
    window.emblaApiMain = emblaApiMain;
    const initZoomButton = ()=>{
        const zoomBtn = document.querySelector(".product-gallery-zoom-btn");
        const zoomModal = document.querySelector(".product-gallery-zoom-modal");
        const zoomClose = document.querySelector(".product-gallery-zoom-close");
        const zoomContainer = zoomModal ? zoomModal.querySelector(".embla-zoom__container") : null;
        const thumbnailsContainer = zoomModal ? zoomModal.querySelector(".product-gallery-zoom-thumbnails") : null;
        if (!zoomBtn || !zoomModal || !zoomContainer) return;
        let emblaZoomApi = null;
        const getAllImages = ()=>{
            const allSlides = document.querySelectorAll(".embla-pdp__viewport .embla__slide");
            const images = [];
            if (allSlides.length > 0) allSlides.forEach((slide)=>{
                const img = slide.querySelector("img");
                if (img && img.src) images.push(img.src);
            });
            else {
                // Fallback for single image products
                const singleImage = document.querySelector(".product-main__top-gallery-image-wrapper img");
                if (singleImage && singleImage.src) images.push(singleImage.src);
            }
            return images;
        };
        const getLargeImageSrc = (src)=>{
            let largeImageSrc = src.replace(/([?&])width=\d+/, "$1width=2000");
            if (!largeImageSrc.includes("width=")) {
                if (largeImageSrc.includes("?")) largeImageSrc += "&width=2000";
                else largeImageSrc += "?width=2000";
            }
            return largeImageSrc;
        };
        const getThumbImageSrc = (src)=>{
            let thumbSrc = src.replace(/([?&])width=\d+/, "$1width=150");
            if (!thumbSrc.includes("width=")) {
                if (thumbSrc.includes("?")) thumbSrc += "&width=150";
                else thumbSrc += "?width=150";
            }
            return thumbSrc;
        };
        const createZoomSlides = (images)=>{
            zoomContainer.innerHTML = "";
            images.forEach((src)=>{
                const slide = document.createElement("div");
                slide.className = "embla-zoom__slide";
                const img = document.createElement("img");
                img.src = getLargeImageSrc(src);
                img.alt = "Product image";
                img.style.maxWidth = "100%";
                img.style.maxHeight = "80vh";
                img.style.objectFit = "contain";
                slide.appendChild(img);
                zoomContainer.appendChild(slide);
            });
        };
        const createThumbnails = (images, activeIndex = 0)=>{
            if (!thumbnailsContainer) return;
            thumbnailsContainer.innerHTML = "";
            images.forEach((src, index)=>{
                const thumb = document.createElement("div");
                thumb.className = "product-gallery-zoom-thumb";
                if (index === activeIndex) thumb.classList.add("active");
                const thumbImg = document.createElement("img");
                thumbImg.src = getThumbImageSrc(src);
                thumbImg.alt = `Thumbnail ${index + 1}`;
                thumb.appendChild(thumbImg);
                thumb.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    if (emblaZoomApi) emblaZoomApi.scrollTo(index);
                });
                thumbnailsContainer.appendChild(thumb);
            });
        };
        const updateActiveThumbnail = ()=>{
            if (!emblaZoomApi) return;
            const selectedIndex = emblaZoomApi.selectedScrollSnap();
            const thumbs = thumbnailsContainer.querySelectorAll(".product-gallery-zoom-thumb");
            thumbs.forEach((thumb, i)=>{
                thumb.classList.toggle("active", i === selectedIndex);
            });
        };
        const openZoom = ()=>{
            const allImages = getAllImages();
            const currentIndex = emblaApiMain ? emblaApiMain.selectedScrollSnap() : 0;
            if (allImages.length > 0) {
                createZoomSlides(allImages);
                const zoomViewport = zoomModal.querySelector(".embla-zoom__viewport");
                if ((0, $2dbSv.default) && zoomViewport) {
                    emblaZoomApi = (0, $2dbSv.default)(zoomViewport, {
                        loop: false,
                        startIndex: currentIndex
                    });
                    createThumbnails(allImages, currentIndex);
                    emblaZoomApi.on("select", updateActiveThumbnail);
                }
                zoomModal.classList.add("active");
                document.body.style.overflow = "hidden";
            }
        };
        const closeZoom = ()=>{
            if (emblaZoomApi) {
                emblaZoomApi.destroy();
                emblaZoomApi = null;
            }
            zoomModal.classList.remove("active");
            document.body.style.overflow = "";
        };
        zoomBtn.addEventListener("click", openZoom);
        zoomClose.addEventListener("click", (e)=>{
            e.stopPropagation();
            closeZoom();
        });
        zoomModal.addEventListener("click", (e)=>{
            if (e.target === zoomModal) closeZoom();
        });
        const zoomContent = zoomModal.querySelector(".product-gallery-zoom-content");
        if (zoomContent) zoomContent.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        document.addEventListener("keydown", (e)=>{
            if (e.key === "Escape" && zoomModal.classList.contains("active")) closeZoom();
        });
    };
    initZoomButton();
    const prevBtn = emblaNode.querySelector(".embla__button--prev");
    const nextBtn = emblaNode.querySelector(".embla__button--next");
    const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(emblaApiMain, emblaApiThumb);
    const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(emblaApiMain, emblaApiThumb);
    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApiMain, prevBtn, nextBtn);
    // Initialize dots carousel
    const dotsViewport = document.querySelector(".embla-dots__viewport");
    const dotsContainer = document.querySelector(".embla-dots__container");
    // console.log("Dots container found:", dotsContainer);
    // console.log("EmblaApiMain:", emblaApiMain);
    let emblaApiDots = null;
    if (dotsContainer) {
        const createDots = ()=>{
            const slideCount = emblaApiMain.slideNodes().length;
            console.log("Creating dots, slide count:", slideCount);
            dotsContainer.innerHTML = "";
            for(let i = 0; i < slideCount; i++){
                const dotSlide = document.createElement("div");
                dotSlide.className = "embla-dots__slide";
                const dot = document.createElement("button");
                dot.className = "product-main__gallery-dot";
                dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
                dot.addEventListener("click", ()=>{
                    emblaApiMain.scrollTo(i);
                    // Auto-scroll dots to keep active dot visible (10 dots per view)
                    if (emblaApiDots) {
                        const targetIndex = Math.max(0, i - 5); // Center the clicked dot (5 dots on each side)
                        emblaApiDots.scrollTo(targetIndex);
                    }
                });
                dotSlide.appendChild(dot);
                dotsContainer.appendChild(dotSlide);
            }
            // Initialize dots carousel if more than 10 dots
            if (slideCount > 10) {
                const OPTIONS_DOTS = {
                    containScroll: "keepSnaps",
                    dragFree: true,
                    slidesToScroll: 1
                };
                emblaApiDots = (0, $2dbSv.default)(dotsViewport, OPTIONS_DOTS);
            }
        // console.log("Dots created: ", dotsContainer.children.length);
        };
        const updateDots = ()=>{
            const dots = dotsContainer.querySelectorAll(".product-main__gallery-dot");
            const selectedIndex = emblaApiMain.selectedScrollSnap();
            console.log("Updating dots, selectedIndex:", selectedIndex, "total dots:", dots.length);
            dots.forEach((dot, index)=>{
                const isActive = index === selectedIndex;
                dot.classList.toggle("active", isActive);
            // console.log(`Dot ${index}: active = ${isActive}`);
            });
            // Auto-center active dot in dots carousel (10 dots per view)
            if (emblaApiDots && dots.length > 10) {
                const targetIndex = Math.max(0, selectedIndex - 5); // Center the active dot (5 dots on each side)
                emblaApiDots.scrollTo(targetIndex);
            }
        };
        emblaApiMain.on("init", ()=>{
            createDots();
            updateDots(); // Call updateDots immediately after creating dots
        });
        emblaApiMain.on("select", updateDots);
        emblaApiMain.on("reInit", ()=>{
            createDots();
            updateDots();
        });
        // Also call updateDots if embla is already initialized
        if (emblaApiMain.slideNodes().length > 0) updateDots();
    }
    emblaApiMain.on("destroy", removeThumbBtnsClickHandlers).on("destroy", removeToggleThumbBtnsActive).on("destroy", removePrevNextBtnsClickHandlers);
    emblaApiThumb.on("destroy", removeThumbBtnsClickHandlers).on("destroy", removeToggleThumbBtnsActive);
    function findImageIndex(id, jump) {
        document.querySelectorAll(".embla-pdp__viewport .embla__slide").forEach((s, i)=>{
            let vid = s.getAttribute("data-variant-id");
            if (id == vid) {
                scrollToByElement(s, jump);
                return s;
            } else return null;
        });
    }
    function scrollToByElement(slideElement, jump) {
        const slideIndex = emblaApiMain.slideNodes().indexOf(slideElement);
        emblaApiMain.scrollTo(slideIndex, jump);
        emblaApiThumb.scrollTo(slideIndex, jump);
    }
    document.querySelectorAll(".image-jumper").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            let _id = e.target.getAttribute("data-variant-id");
            if (!_id) ;
            else findImageIndex(_id, false);
        });
    });
    if (_variant) findImageIndex(_variant, true);
} else return null;

});
parcelRegister("2dbSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c6026a5085889c$export$2e2bcd8739ae039);
function $19c6026a5085889c$var$isNumber(subject) {
    return typeof subject === "number";
}
function $19c6026a5085889c$var$isString(subject) {
    return typeof subject === "string";
}
function $19c6026a5085889c$var$isBoolean(subject) {
    return typeof subject === "boolean";
}
function $19c6026a5085889c$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === "[object Object]";
}
function $19c6026a5085889c$var$mathAbs(n) {
    return Math.abs(n);
}
function $19c6026a5085889c$var$mathSign(n) {
    return Math.sign(n);
}
function $19c6026a5085889c$var$deltaAbs(valueB, valueA) {
    return $19c6026a5085889c$var$mathAbs(valueB - valueA);
}
function $19c6026a5085889c$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($19c6026a5085889c$var$mathAbs(valueB) <= $19c6026a5085889c$var$mathAbs(valueA)) return 0;
    const diff = $19c6026a5085889c$var$deltaAbs($19c6026a5085889c$var$mathAbs(valueB), $19c6026a5085889c$var$mathAbs(valueA));
    return $19c6026a5085889c$var$mathAbs(diff / valueB);
}
function $19c6026a5085889c$var$arrayKeys(array) {
    return $19c6026a5085889c$var$objectKeys(array).map(Number);
}
function $19c6026a5085889c$var$arrayLast(array) {
    return array[$19c6026a5085889c$var$arrayLastIndex(array)];
}
function $19c6026a5085889c$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $19c6026a5085889c$var$arrayIsLastIndex(array, index) {
    return index === $19c6026a5085889c$var$arrayLastIndex(array);
}
function $19c6026a5085889c$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $19c6026a5085889c$var$objectKeys(object) {
    return Object.keys(object);
}
function $19c6026a5085889c$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $19c6026a5085889c$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $19c6026a5085889c$var$isObject(valueA) && $19c6026a5085889c$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $19c6026a5085889c$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $19c6026a5085889c$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== "undefined" && evt instanceof ownerWindow.MouseEvent;
}
function $19c6026a5085889c$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($19c6026a5085889c$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $19c6026a5085889c$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ("addEventListener" in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $19c6026a5085889c$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $19c6026a5085889c$var$EventStore();
    const timeStep = 1000 / 60;
    let lastTimeStamp = null;
    let lag = 0;
    let animationFrame = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, "visibilitychange", ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationFrame) return;
        if (!lastTimeStamp) lastTimeStamp = timeStamp;
        const elapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        lag += elapsed;
        while(lag >= timeStep){
            update(timeStep);
            lag -= timeStep;
        }
        const lagOffset = lag / timeStep;
        render(lagOffset);
        if (animationFrame) ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationFrame) return;
        animationFrame = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationFrame);
        lastTimeStamp = null;
        lag = 0;
        animationFrame = 0;
    }
    function reset() {
        lastTimeStamp = null;
        lag = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: ()=>update(timeStep),
        render: render
    };
    return self;
}
function $19c6026a5085889c$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === "rtl";
    const isVertical = axis === "y";
    const scroll = isVertical ? "y" : "x";
    const cross = isVertical ? "x" : "y";
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return "top";
        return isRightToLeft ? "right" : "left";
    }
    function getEndEdge() {
        if (isVertical) return "bottom";
        return isRightToLeft ? "left" : "right";
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $19c6026a5085889c$var$Limit(min = 0, max = 0) {
    const length = $19c6026a5085889c$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $19c6026a5085889c$var$Counter(max, start, loop) {
    const { constrain: constrain } = $19c6026a5085889c$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $19c6026a5085889c$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $19c6026a5085889c$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $19c6026a5085889c$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        "INPUT",
        "SELECT",
        "TEXTAREA"
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $19c6026a5085889c$var$EventStore();
    const dragEvents = $19c6026a5085889c$var$EventStore();
    const goToNextThreshold = $19c6026a5085889c$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($19c6026a5085889c$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, "dragstart", (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, "touchmove", ()=>undefined, nonPassiveEvent).add(node, "touchend", ()=>undefined).add(node, "touchstart", downIfAllowed).add(node, "mousedown", downIfAllowed).add(node, "touchcancel", up).add(node, "contextmenu", up).add(node, "click", click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, "touchmove", move, nonPassiveEvent).add(node, "touchend", up).add(node, "mousemove", move, nonPassiveEvent).add(node, "mouseup", up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || "";
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? "mouse" : "touch";
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($19c6026a5085889c$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $19c6026a5085889c$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $19c6026a5085889c$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $19c6026a5085889c$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit("pointerDown");
    }
    function move(evt) {
        const isTouchEvt = !$19c6026a5085889c$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $19c6026a5085889c$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $19c6026a5085889c$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $19c6026a5085889c$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit("pointerUp");
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $19c6026a5085889c$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === "x" ? "X" : "Y"}`;
        return ($19c6026a5085889c$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $19c6026a5085889c$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $19c6026a5085889c$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $19c6026a5085889c$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $19c6026a5085889c$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $19c6026a5085889c$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit("resize");
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($19c6026a5085889c$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $19c6026a5085889c$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek(timeStep) {
        const fixedDeltaTimeSeconds = timeStep / 1000;
        const duration = scrollDuration * fixedDeltaTimeSeconds;
        const diff = target.get() - location.get();
        const isInstant = !scrollDuration;
        let directionDiff = 0;
        if (isInstant) {
            bodyVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            directionDiff = diff;
        } else {
            previousLocation.set(location);
            bodyVelocity += diff / duration;
            bodyVelocity *= scrollFriction;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity * fixedDeltaTimeSeconds);
            directionDiff = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $19c6026a5085889c$var$mathSign(directionDiff);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $19c6026a5085889c$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return bodyVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $19c6026a5085889c$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $19c6026a5085889c$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? "min" : "max";
        const diffToEdge = $19c6026a5085889c$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $19c6026a5085889c$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $19c6026a5085889c$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $19c6026a5085889c$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $19c6026a5085889c$var$deltaAbs(bound, snap) < 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $19c6026a5085889c$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $19c6026a5085889c$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $19c6026a5085889c$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === "keepSnaps") return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $19c6026a5085889c$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $19c6026a5085889c$var$arrayLast(scrollSnaps);
    const limit = $19c6026a5085889c$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $19c6026a5085889c$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $19c6026a5085889c$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $19c6026a5085889c$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $19c6026a5085889c$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$19c6026a5085889c$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($19c6026a5085889c$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$19c6026a5085889c$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $19c6026a5085889c$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === "keepSnaps";
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $19c6026a5085889c$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $19c6026a5085889c$var$arrayLast(groups[0]) + 1;
                return $19c6026a5085889c$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $19c6026a5085889c$var$arrayLastIndex(slideIndexes) - $19c6026a5085889c$var$arrayLast(groups)[0] + 1;
                return $19c6026a5085889c$var$arrayFromNumber(range, $19c6026a5085889c$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $19c6026a5085889c$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$19c6026a5085889c$var$mathAbs(a) - $19c6026a5085889c$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$19c6026a5085889c$var$mathAbs(d1.diff) - $19c6026a5085889c$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$19c6026a5085889c$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $19c6026a5085889c$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $19c6026a5085889c$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit("select");
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $19c6026a5085889c$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit("slideFocusStart");
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$19c6026a5085889c$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit("slideFocus");
        }
        eventStore.add(document, "keydown", registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, "focus", (evt)=>{
                if ($19c6026a5085889c$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === "Tab") lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $19c6026a5085889c$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $19c6026a5085889c$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $19c6026a5085889c$var$Translate(axis, container) {
    const translate = axis.scroll === "x" ? x : y;
    const containerStyle = container.style;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(axis.direction(target));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = "";
        if (!container.getAttribute("style")) container.removeAttribute("style");
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $19c6026a5085889c$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $19c6026a5085889c$var$arrayKeys(slideSizesWithGaps);
    const descItems = $19c6026a5085889c$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? "end" : "start";
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $19c6026a5085889c$var$Vector1D(-1),
                translate: $19c6026a5085889c$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $19c6026a5085889c$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === "childList") {
                emblaApi.reInit();
                eventHandler.emit("slidesChanged");
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($19c6026a5085889c$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $19c6026a5085889c$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit("slidesInView");
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $19c6026a5085889c$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $19c6026a5085889c$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $19c6026a5085889c$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($19c6026a5085889c$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $19c6026a5085889c$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($19c6026a5085889c$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $19c6026a5085889c$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $19c6026a5085889c$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $19c6026a5085889c$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $19c6026a5085889c$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $19c6026a5085889c$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $19c6026a5085889c$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $19c6026a5085889c$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $19c6026a5085889c$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $19c6026a5085889c$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $19c6026a5085889c$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $19c6026a5085889c$var$PercentOfView(viewSize);
    const alignment = $19c6026a5085889c$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $19c6026a5085889c$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $19c6026a5085889c$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $19c6026a5085889c$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$19c6026a5085889c$var$arrayLast(snaps) + $19c6026a5085889c$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $19c6026a5085889c$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $19c6026a5085889c$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $19c6026a5085889c$var$Counter($19c6026a5085889c$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $19c6026a5085889c$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } }, timeStep)=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek(timeStep);
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, lagOffset)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        if (hasSettled && !dragHandler.pointerDown()) {
            animation.stop();
            eventHandler.emit("settle");
        }
        if (!hasSettled) eventHandler.emit("scroll");
        const interpolatedLocation = location.get() * lagOffset + previousLocation.get() * (1 - lagOffset);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
    };
    const animation = $19c6026a5085889c$var$Animations(ownerDocument, ownerWindow, (timeStep)=>update(engine, timeStep), (lagOffset)=>render(engine, lagOffset));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $19c6026a5085889c$var$Vector1D(startLocation);
    const previousLocation = $19c6026a5085889c$var$Vector1D(startLocation);
    const offsetLocation = $19c6026a5085889c$var$Vector1D(startLocation);
    const target = $19c6026a5085889c$var$Vector1D(startLocation);
    const scrollBody = $19c6026a5085889c$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $19c6026a5085889c$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $19c6026a5085889c$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $19c6026a5085889c$var$ScrollProgress(limit);
    const eventStore = $19c6026a5085889c$var$EventStore();
    const slidesInView = $19c6026a5085889c$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $19c6026a5085889c$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $19c6026a5085889c$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $19c6026a5085889c$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $19c6026a5085889c$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $19c6026a5085889c$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $19c6026a5085889c$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $19c6026a5085889c$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $19c6026a5085889c$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $19c6026a5085889c$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $19c6026a5085889c$var$Translate(axis, container)
    };
    return engine;
}
function $19c6026a5085889c$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $19c6026a5085889c$var$defaultOptions = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $19c6026a5085889c$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $19c6026a5085889c$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $19c6026a5085889c$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$19c6026a5085889c$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $19c6026a5085889c$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $19c6026a5085889c$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $19c6026a5085889c$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $19c6026a5085889c$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $19c6026a5085889c$var$EventStore();
    const eventHandler = $19c6026a5085889c$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($19c6026a5085889c$var$defaultOptions, $19c6026a5085889c$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $19c6026a5085889c$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $19c6026a5085889c$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $19c6026a5085889c$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, "change", reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit("reInit");
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit("destroy");
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit("init"), 0);
    return self;
}
$19c6026a5085889c$export$2e2bcd8739ae039.globalOptions = undefined;

});


// bump
const $d7be782da32a240e$var$relatedProductsCl = {
    wrapper: "related-products-wrapper-js",
    cardBtn: "card-product-small-button-js",
    popup: "related-products-popup-js",
    popupOverlay: "related-products-popup-overlay-js",
    popupCloseBtn: "related-products-popup-close-js",
    quantityInputWrapper: "related-products-popup-quantity-input-wrapper-js",
    quantityInput: "related-products-popup-quantity-input-js",
    quantityPlusBtn: "related-products-popup-quantity-plus-js",
    quantityMinusBtn: "related-products-popup-quantity-minus-js",
    basketBtn: "related-products-popup-basket-btn-js",
    radio: "related-products-popup-radio-js",
    product: "related-products-popup-product-js",
    priceTag: "related-products-popup-price-js"
};
const $d7be782da32a240e$var$switchPriceTag = function(chosenVariant) {
    const priceTags = chosenVariant.closest("." + $d7be782da32a240e$var$relatedProductsCl.product).querySelectorAll("." + $d7be782da32a240e$var$relatedProductsCl.priceTag);
    priceTags.forEach((tag)=>{
        const tagMoneyEl = tag.querySelector(".money") || tag;
        const previousPrice = tag.getAttribute("data-total-price");
        if (tag.hasAttribute("original-price")) {
            tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-original-price"));
            tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-original-price"));
            tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-original-price-currency"));
            tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
            return;
        }
        tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-price"));
        tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-price"));
        tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-price-currency"));
        tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
    });
};
const $d7be782da32a240e$var$enableQuantityAndBasket = function(radio) {
    const productWrapper = radio.closest("." + $d7be782da32a240e$var$relatedProductsCl.product);
    // productWrapper.querySelector('.' + relatedProductsCl.basketBtn).removeAttribute('disabled');
    // quantityWrapper.removeAttribute('inactive');
    const quantityWrapper = productWrapper.querySelector("." + $d7be782da32a240e$var$relatedProductsCl.quantityInputWrapper);
    const quantityInput = quantityWrapper.querySelector("input");
    quantityInput.setAttribute("data-chosen-variant-inventory", radio.getAttribute("data-variant-inventory"));
    quantityInput.setAttribute("max", radio.getAttribute("data-variant-inventory"));
    quantityInput.value = 1;
    quantityInput.setAttribute("value", 1);
};
const $d7be782da32a240e$var$updateProductQuantity = function(quantityInput, action = "plus") {
    const currentQuantity = +quantityInput.value;
    let newQuantity;
    if (action === "plus") {
        newQuantity = currentQuantity + 1;
        quantityInput.value = newQuantity;
        quantityInput.setAttribute("value", newQuantity);
        $d7be782da32a240e$var$calculatePriceTag(quantityInput.closest("." + $d7be782da32a240e$var$relatedProductsCl.product));
    } else if (action === "minus" && currentQuantity > 1) {
        newQuantity = currentQuantity - 1;
        quantityInput.value = newQuantity;
        quantityInput.setAttribute("value", newQuantity);
        $d7be782da32a240e$var$calculatePriceTag(quantityInput.closest("." + $d7be782da32a240e$var$relatedProductsCl.product), "minus");
    } else if (action === "manual") {
        newQuantity = currentQuantity;
        quantityInput.value = newQuantity;
        quantityInput.setAttribute("value", newQuantity);
        $d7be782da32a240e$var$calculatePriceTag(quantityInput.closest("." + $d7be782da32a240e$var$relatedProductsCl.product), "manual", newQuantity);
    }
};
const $d7be782da32a240e$var$calculatePriceTag = function(product, action = "plus", quantity = 1) {
    const priceTags = product.querySelectorAll("." + $d7be782da32a240e$var$relatedProductsCl.priceTag);
    const renderNewPrice = function(priceTag, previousTotalStr, newTotal) {
        const tagMoneyEl = priceTag.querySelector(".money") || priceTag;
        priceTag.setAttribute("data-total-price", newTotal.toFixed(2));
        tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousTotalStr, newTotal.toFixed(2));
    };
    priceTags.forEach((tag)=>{
        const previousTotalStr = tag.getAttribute("data-total-price");
        const previousTotal = +tag.getAttribute("data-total-price");
        const productPrice = +tag.getAttribute("data-product-price");
        let newTotal;
        if (action === "plus") {
            newTotal = previousTotal + productPrice * quantity;
            renderNewPrice(tag, previousTotalStr, newTotal);
        } else if (action === "minus") {
            newTotal = previousTotal - productPrice * quantity;
            renderNewPrice(tag, previousTotalStr, newTotal);
        } else if (action === "manual") {
            newTotal = productPrice * quantity;
            renderNewPrice(tag, previousTotalStr, newTotal);
        }
    });
};
/* GENERAL FUNCTIONS - END */ const $d7be782da32a240e$var$showRelatedProductsPopup = function(popup) {
    popup.setAttribute("active", "");
};
const $d7be782da32a240e$var$hideRelatedProductsPopup = function(popup) {
    popup.removeAttribute("active");
};
const $d7be782da32a240e$var$addRelatedProductsEvents = function(relatedProductsPopup) {
    const relatedProductsWrapper = document.querySelector("." + $d7be782da32a240e$var$relatedProductsCl.wrapper);
    relatedProductsWrapper.addEventListener("click", (e)=>{
        if (e.target.classList.contains($d7be782da32a240e$var$relatedProductsCl.cardBtn)) $d7be782da32a240e$var$showRelatedProductsPopup(relatedProductsPopup);
    });
    relatedProductsPopup.addEventListener("click", (e)=>{
        if (!relatedProductsPopup.hasAttribute("active")) return;
        if (e.target.closest("button." + $d7be782da32a240e$var$relatedProductsCl.popupCloseBtn) || e.target.classList.contains($d7be782da32a240e$var$relatedProductsCl.popupOverlay)) $d7be782da32a240e$var$hideRelatedProductsPopup(relatedProductsPopup);
        if (e.target.closest("." + $d7be782da32a240e$var$relatedProductsCl.radio)) {
            const radioInput = e.target.closest("." + $d7be782da32a240e$var$relatedProductsCl.radio).querySelector("input");
            if (radioInput.hasAttribute("out-of-stock")) return;
            $d7be782da32a240e$var$enableQuantityAndBasket(radioInput);
            $d7be782da32a240e$var$switchPriceTag(radioInput);
        }
        if (e.target.closest("." + $d7be782da32a240e$var$relatedProductsCl.quantityPlusBtn)) $d7be782da32a240e$var$updateProductQuantity(e.target.closest("." + $d7be782da32a240e$var$relatedProductsCl.quantityInputWrapper).querySelector("input"));
        if (e.target.closest("." + $d7be782da32a240e$var$relatedProductsCl.quantityMinusBtn)) $d7be782da32a240e$var$updateProductQuantity(e.target.closest("." + $d7be782da32a240e$var$relatedProductsCl.quantityInputWrapper).querySelector("input"), "minus");
    });
    relatedProductsPopup.querySelectorAll("." + $d7be782da32a240e$var$relatedProductsCl.quantityInputWrapper).forEach((input)=>{
        input.querySelector("input").addEventListener("keyup", (e)=>{
            if (e.target.value < 1) e.target.value = 1;
            $d7be782da32a240e$var$updateProductQuantity(e.target, "manual");
        });
    });
};
function $d7be782da32a240e$export$2e2bcd8739ae039() {
    const relatedProductsPopup = document.querySelector("." + $d7be782da32a240e$var$relatedProductsCl.popup);
    if (!relatedProductsPopup) return;
    $d7be782da32a240e$var$addRelatedProductsEvents(relatedProductsPopup);
}


/*
  _________________________
< Here be a countdown timer >
  -------------------------
         \   ^__^ 
          \  (oo)\_______
             (__)\       )\/\
                 ||----w |
                 ||     ||
*/ function $50633e7301cb8da8$var$getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor(total / 1000 % 60);
    const minutes = Math.floor(total / 1000 / 60 % 60);
    const hours = Math.floor(total / 3600000 % 24);
    const days = Math.floor(total / 86400000);
    return {
        total: total,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}
function $50633e7301cb8da8$var$countdownVisibility(today, schedule, deadline) {
    let visibility = true;
    let weekend = false;
    // Check if it's a weekend
    if (today.getDay() === 0 || today.getDay() === 6) weekend = true;
    // Get today's short date
    const ye = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(today);
    const mo = new Intl.DateTimeFormat("en", {
        month: "2-digit"
    }).format(today);
    const da = new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(today);
    const shortToday = `${da}/${mo}/${ye}`;
    // Set deadline time for weekdays and weekends
    const currentTimeMilliseconds = new Date(today).getTime();
    // If today is in the schedule of holidays, then hide the countdown
    if (schedule.includes(shortToday)) visibility = false;
    else // For weekends, check visibility
    if (weekend) {
        const weekendCutoff = new Date(today);
        weekendCutoff.setHours(15, 0, 0, 0); // 3 PM cutoff
        if (currentTimeMilliseconds > weekendCutoff.getTime()) visibility = false;
    } else {
        // For weekdays, check visibility against 10 PM
        const weekdayCutoff = new Date(today);
        weekdayCutoff.setHours(22, 0, 0, 0); // 10 PM cutoff
        if (currentTimeMilliseconds > weekdayCutoff.getTime()) visibility = false;
    }
    return visibility;
}
function $50633e7301cb8da8$var$initializeClock(el, deadline, schedule, today) {
    const visibility = $50633e7301cb8da8$var$countdownVisibility(today, schedule, deadline);
    // Completely hide if it's gone past the cutoff point
    if (!visibility) {
        el.style.display = "none";
        return; // Stop further execution if element should be hidden
    }
    const timeinterval = setInterval(()=>{
        const t = $50633e7301cb8da8$var$getTimeRemaining(deadline);
        const output = el.querySelector("span.countdown-js");
        if (t.total <= 0) {
            clearInterval(timeinterval); // Stop the countdown once it's passed the cutoff
            el.style.display = "none"; // Hide the element if the time has passed
        } else output.innerHTML = "Order in " + t.hours + " hours " + t.minutes + " minutes and " + t.seconds + " seconds";
    }, 1000);
}
function $50633e7301cb8da8$export$2e2bcd8739ae039() {
    const url = window.location.href;
    if (url.includes("/products/")) {
        // WHERE TO PLACE THE COUNTDOWN dahs
        const clock = document.querySelector('[data-countdown="active"]');
        // IF CLOCK SPAN EXISTS, INITIALIZE THE CLOCK
        if (clock) {
            // GET SCHEDULE FROM ATTRIBUTES
            let schedule = clock.getAttribute("data-holidays");
            schedule = schedule.split(",");
            // CREATE DEADLINE
            const today = new Date();
            let deadline;
            // Check if today is Saturday or Sunday
            const day = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
            if (day === 0 || day === 6) // Set cutoff for weekend at 3 PM
            deadline = new Date(today.setHours(15, 0, 0, 0));
            else // Set cutoff for weekdays at 10 PM
            deadline = new Date(today.setHours(22, 0, 0, 0));
            // Adjust deadline to the next day if the current time has passed the cutoff
            if (today > deadline) deadline.setDate(deadline.getDate() + 1); // Move to next day
            // INIT CLOCK
            $50633e7301cb8da8$var$initializeClock(clock, deadline, schedule, today);
        }
    }
} /*

  _________________________
< YEEHAW >
  -------------------------
     >>\.
    /_  )`.
   /  _)`^)`.   _.---. _
  (_,' \  `^-)""      `.\
        |              | \
        \              / |
       / \  /.___.'\  (\ (_
      < ,"||     \ |`. \`-'
       \\ ()      )|  )/
       |_>|>     /_] //
         /_]        /_]

*/ 



var $876e72363b33df3f$exports = {};
// shim for using process in browser
var $876e72363b33df3f$var$process = $876e72363b33df3f$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $876e72363b33df3f$var$cachedSetTimeout;
var $876e72363b33df3f$var$cachedClearTimeout;
function $876e72363b33df3f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $876e72363b33df3f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $876e72363b33df3f$var$cachedSetTimeout = setTimeout;
        else $876e72363b33df3f$var$cachedSetTimeout = $876e72363b33df3f$var$defaultSetTimout;
    } catch (e) {
        $876e72363b33df3f$var$cachedSetTimeout = $876e72363b33df3f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $876e72363b33df3f$var$cachedClearTimeout = clearTimeout;
        else $876e72363b33df3f$var$cachedClearTimeout = $876e72363b33df3f$var$defaultClearTimeout;
    } catch (e) {
        $876e72363b33df3f$var$cachedClearTimeout = $876e72363b33df3f$var$defaultClearTimeout;
    }
})();
function $876e72363b33df3f$var$runTimeout(fun) {
    if ($876e72363b33df3f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($876e72363b33df3f$var$cachedSetTimeout === $876e72363b33df3f$var$defaultSetTimout || !$876e72363b33df3f$var$cachedSetTimeout) && setTimeout) {
        $876e72363b33df3f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $876e72363b33df3f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $876e72363b33df3f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $876e72363b33df3f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $876e72363b33df3f$var$runClearTimeout(marker) {
    if ($876e72363b33df3f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($876e72363b33df3f$var$cachedClearTimeout === $876e72363b33df3f$var$defaultClearTimeout || !$876e72363b33df3f$var$cachedClearTimeout) && clearTimeout) {
        $876e72363b33df3f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $876e72363b33df3f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $876e72363b33df3f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $876e72363b33df3f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $876e72363b33df3f$var$queue = [];
var $876e72363b33df3f$var$draining = false;
var $876e72363b33df3f$var$currentQueue;
var $876e72363b33df3f$var$queueIndex = -1;
function $876e72363b33df3f$var$cleanUpNextTick() {
    if (!$876e72363b33df3f$var$draining || !$876e72363b33df3f$var$currentQueue) return;
    $876e72363b33df3f$var$draining = false;
    if ($876e72363b33df3f$var$currentQueue.length) $876e72363b33df3f$var$queue = $876e72363b33df3f$var$currentQueue.concat($876e72363b33df3f$var$queue);
    else $876e72363b33df3f$var$queueIndex = -1;
    if ($876e72363b33df3f$var$queue.length) $876e72363b33df3f$var$drainQueue();
}
function $876e72363b33df3f$var$drainQueue() {
    if ($876e72363b33df3f$var$draining) return;
    var timeout = $876e72363b33df3f$var$runTimeout($876e72363b33df3f$var$cleanUpNextTick);
    $876e72363b33df3f$var$draining = true;
    var len = $876e72363b33df3f$var$queue.length;
    while(len){
        $876e72363b33df3f$var$currentQueue = $876e72363b33df3f$var$queue;
        $876e72363b33df3f$var$queue = [];
        while(++$876e72363b33df3f$var$queueIndex < len)if ($876e72363b33df3f$var$currentQueue) $876e72363b33df3f$var$currentQueue[$876e72363b33df3f$var$queueIndex].run();
        $876e72363b33df3f$var$queueIndex = -1;
        len = $876e72363b33df3f$var$queue.length;
    }
    $876e72363b33df3f$var$currentQueue = null;
    $876e72363b33df3f$var$draining = false;
    $876e72363b33df3f$var$runClearTimeout(timeout);
}
$876e72363b33df3f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $876e72363b33df3f$var$queue.push(new $876e72363b33df3f$var$Item(fun, args));
    if ($876e72363b33df3f$var$queue.length === 1 && !$876e72363b33df3f$var$draining) $876e72363b33df3f$var$runTimeout($876e72363b33df3f$var$drainQueue);
};
// v8 likes predictible objects
function $876e72363b33df3f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$876e72363b33df3f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$876e72363b33df3f$var$process.title = "browser";
$876e72363b33df3f$var$process.browser = true;
$876e72363b33df3f$var$process.env = {};
$876e72363b33df3f$var$process.argv = [];
$876e72363b33df3f$var$process.version = ""; // empty string to avoid regexp issues
$876e72363b33df3f$var$process.versions = {};
function $876e72363b33df3f$var$noop() {}
$876e72363b33df3f$var$process.on = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.addListener = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.once = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.off = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.removeListener = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.removeAllListeners = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.emit = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.prependListener = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.prependOnceListener = $876e72363b33df3f$var$noop;
$876e72363b33df3f$var$process.listeners = function(name) {
    return [];
};
$876e72363b33df3f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$876e72363b33df3f$var$process.cwd = function() {
    return "/";
};
$876e72363b33df3f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$876e72363b33df3f$var$process.umask = function() {
    return 0;
};


const $a0586330b06ed090$var$productOptionsCl = {
    popup: "product-popup-js",
    popupOverlay: "product-popup-overlay-js",
    popupCloseBtn: "product-popup-close-js",
    popupConfirmBtn: "product-popup-confirm-button-js",
    popupOpenEl: "product-popup-open-js",
    colorRadio: "product-popup-radio-js",
    quantityWrapper: "product-quantity-wrapper-js",
    quantityInput: "product-options-quantity-input-js",
    quantityPlusBtn: "product-quantity-plus-js",
    quantityMinusBtn: "product-quantity-minus-js",
    strengthWrapper: "product-strength-wrapper-js",
    strengthRadio: "product-strength-radio-js",
    priceTag: "product-options-price-js",
    basketBtn: "product-options-basket-btn-js"
};
/* GENERAL FUNCTIONS - START */ const $a0586330b06ed090$var$resetProductQuantity = function(quantityInput) {
    quantityInput.value = 1;
    quantityInput.setAttribute("value", 1);
};
const $a0586330b06ed090$var$switchPriceTag = function(chosenVariant) {
    // console.log(chosenVariant);
    const priceTags = document.querySelectorAll("." + $a0586330b06ed090$var$productOptionsCl.priceTag);
    const beforeSalePrice = chosenVariant.getAttribute("data-variant-original-price-currency");
    const activePrice = chosenVariant.getAttribute("data-variant-price-currency");
    let isOnSale = false;
    if (chosenVariant.getAttribute("data-variant-original-price") == "" || chosenVariant.getAttribute("data-variant-original-price") == null) isOnSale = false;
    else isOnSale = true;
    // show the sale price [now / was] 
    if (isOnSale) {
        document.querySelector(`[sale-was-ref]`).innerHTML = `Was ${beforeSalePrice}`;
        document.querySelector(`[active-price-ref]`).classList.add(`product-main__top-details-price--sale`);
        document.querySelector(`[active-price-ref]`).innerHTML = `Now ${activePrice}`;
        document.querySelector(`[sale-was-ref]`).classList.remove("visually-hidden");
    } else {
        document.querySelector(`[sale-was-ref]`).classList.add("visually-hidden");
        document.querySelector(`[active-price-ref]`).classList.remove(`product-main__top-details-price--sale`);
        document.querySelector(`[active-price-ref]`).innerHTML = `<span>${activePrice}</span>`;
    }
    priceTags.forEach((tag)=>{
        const tagMoneyEl = tag.querySelector(".money") || tag;
        const previousPrice = tag.getAttribute("data-total-price");
        if (tag.hasAttribute("original-price")) {
            tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-original-price"));
            tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-original-price"));
            tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-original-price-currency"));
            tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
            return;
        }
        tag.setAttribute("data-total-price", chosenVariant.getAttribute("data-variant-price"));
        tag.setAttribute("data-product-price", chosenVariant.getAttribute("data-variant-price"));
        tag.setAttribute("data-product-price-currency", chosenVariant.getAttribute("data-variant-price-currency"));
        tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousPrice, tag.getAttribute("data-product-price"));
    });
};
const $a0586330b06ed090$var$calculatePriceTag = function(action = "plus", quantity = 1) {
    const priceTags = document.querySelectorAll("." + $a0586330b06ed090$var$productOptionsCl.priceTag);
    const renderNewPrice = function(priceTag, previousTotalStr, newTotal) {
        const tagMoneyEl = priceTag.querySelector(".money") || priceTag;
        priceTag.setAttribute("data-total-price", newTotal.toFixed(2));
        tagMoneyEl.textContent = tagMoneyEl.textContent.replace(previousTotalStr, newTotal.toFixed(2));
    };
    priceTags.forEach((tag)=>{
        if (tag.getAttribute("data-ignore-price") == "true") return;
        else {
            const previousTotalStr = tag.getAttribute("data-total-price");
            const previousTotal = +tag.getAttribute("data-total-price");
            const productPrice = +tag.getAttribute("data-product-price");
            let newTotal;
            if (action === "plus") {
                newTotal = previousTotal + productPrice * quantity;
                renderNewPrice(tag, previousTotalStr, newTotal);
            } else if (action === "minus") {
                newTotal = previousTotal - productPrice * quantity;
                renderNewPrice(tag, previousTotalStr, newTotal);
            } else if (action === "manual") {
                newTotal = productPrice * quantity;
                renderNewPrice(tag, previousTotalStr, newTotal);
            }
        }
    });
};
/* GENERAL FUNCTIONS - END */ /* PRODUCT QUANTITY - START */ const $a0586330b06ed090$var$updateProductQuantity = function(quantityInput, action = "plus") {
    const currentQuantity = +quantityInput.value;
    let newQuantity;
    if (action === "plus") {
        newQuantity = currentQuantity + 1;
        quantityInput.value = newQuantity;
        quantityInput.setAttribute("value", newQuantity);
        $a0586330b06ed090$var$calculatePriceTag();
    } else if (action === "minus" && currentQuantity > 1) {
        newQuantity = currentQuantity - 1;
        quantityInput.value = newQuantity;
        quantityInput.setAttribute("value", newQuantity);
        $a0586330b06ed090$var$calculatePriceTag("minus");
    } else if (action === "manual") {
        newQuantity = currentQuantity;
        quantityInput.value = newQuantity;
        quantityInput.setAttribute("value", newQuantity);
        $a0586330b06ed090$var$calculatePriceTag("manual", newQuantity);
    }
};
const $a0586330b06ed090$var$addQuantityEvents = function(quantityWrapper) {
    const quantityInput = quantityWrapper.querySelector("." + $a0586330b06ed090$var$productOptionsCl.quantityInput);
    const basketBtn = document.querySelector("." + $a0586330b06ed090$var$productOptionsCl.basketBtn);
    quantityWrapper.addEventListener("click", (e)=>{
        if (e.target.closest("." + $a0586330b06ed090$var$productOptionsCl.quantityPlusBtn)) $a0586330b06ed090$var$updateProductQuantity(quantityInput);
        if (e.target.closest("." + $a0586330b06ed090$var$productOptionsCl.quantityMinusBtn)) $a0586330b06ed090$var$updateProductQuantity(quantityInput, "minus");
    });
    quantityInput.addEventListener("keyup", (e)=>{
        if (e.target.value < 1) e.target.value = 1;
        $a0586330b06ed090$var$updateProductQuantity(quantityInput, "manual");
    });
};
const $a0586330b06ed090$var$initProductQuantity = function() {
    const quantityWrapper = document.querySelector("." + $a0586330b06ed090$var$productOptionsCl.quantityWrapper);
    if (!quantityWrapper) return;
    $a0586330b06ed090$var$addQuantityEvents(quantityWrapper);
};
/* PRODUCT QUANTITY - END */ /* PRODUCT POPUP - START */ const $a0586330b06ed090$var$hideProductPopup = function(currentPopup) {
    currentPopup.removeAttribute("active");
};
const $a0586330b06ed090$var$showProductPopup = function(popup) {
    popup.setAttribute("active", "");
};
const $a0586330b06ed090$var$updateDropdown = function(dropdownInput, clickedRadio, quantityInput) {
    dropdownInput.value = `${clickedRadio.getAttribute("data-colour-option")}`;
    dropdownInput.setAttribute("filled", "");
    $a0586330b06ed090$var$resetProductQuantity(quantityInput);
    $a0586330b06ed090$var$switchPriceTag(clickedRadio);
};
const $a0586330b06ed090$var$addPopupEvents = function(openEl, quantityInput) {
    const popup = openEl.closest("." + $a0586330b06ed090$var$productOptionsCl.popupOpenEl).nextElementSibling;
    const dropdownInput = openEl.querySelector("input");
    const checkedRadio = popup.querySelector("input[checked]");
    if (checkedRadio) dropdownInput.value = checkedRadio.value;
    dropdownInput.setAttribute("filled", "");
    openEl.addEventListener("click", (e)=>{
        $a0586330b06ed090$var$showProductPopup(popup);
    });
    popup.addEventListener("click", (e)=>{
        if (e.target.closest("button." + $a0586330b06ed090$var$productOptionsCl.popupCloseBtn) || e.target.closest("button." + $a0586330b06ed090$var$productOptionsCl.popupConfirmBtn) || e.target.classList.contains($a0586330b06ed090$var$productOptionsCl.popupOverlay)) $a0586330b06ed090$var$hideProductPopup(popup);
        if (e.target.closest("." + $a0586330b06ed090$var$productOptionsCl.colorRadio)) {
            const radio = e.target.closest("." + $a0586330b06ed090$var$productOptionsCl.colorRadio).querySelector("input");
            $a0586330b06ed090$var$hideProductPopup(popup);
            if (radio.hasAttribute("out-of-stock")) return;
            document.querySelector("." + $a0586330b06ed090$var$productOptionsCl.basketBtn).disabled = false;
            $a0586330b06ed090$var$updateDropdown(dropdownInput, radio, quantityInput);
        }
    });
};
const $a0586330b06ed090$var$initProductPopup = function() {
    const openPopupEls = document.querySelectorAll("." + $a0586330b06ed090$var$productOptionsCl.popupOpenEl);
    if (openPopupEls.length < 1) return;
    const quantityInput = document.querySelector("." + $a0586330b06ed090$var$productOptionsCl.quantityInput);
    openPopupEls.forEach((openEl)=>{
        $a0586330b06ed090$var$addPopupEvents(openEl, quantityInput);
    });
};
/* PRODUCT POPUP - END */ /* PRODUCT STRENGTH - START */ const $a0586330b06ed090$var$addStrengthEvents = function(strengthWrapper, strengthRadios, quantityInput) {
    strengthWrapper.addEventListener("click", (e)=>{
        if (e.target.closest("." + $a0586330b06ed090$var$productOptionsCl.strengthRadio)) {
            const radioInput = e.target.closest("." + $a0586330b06ed090$var$productOptionsCl.strengthRadio).querySelector("input");
            if (radioInput.hasAttribute("disabled")) return;
            $a0586330b06ed090$var$resetProductQuantity(quantityInput);
            $a0586330b06ed090$var$switchPriceTag(radioInput);
            let _variant = radioInput.value;
            if (_variant == "10mg") {
                document.querySelectorAll(".product-popup-radio-js input.twenty-only").forEach((f)=>{
                    f.parentElement.classList.add("hidden");
                });
                document.querySelectorAll(".product-popup-radio-js input").forEach((f)=>{
                    f.classList.add("filtered");
                });
                document.querySelectorAll(".product-popup-radio-js input.ten-only").forEach((f)=>{
                    f.parentElement.classList.remove("hidden");
                });
            }
            if (_variant == "20mg") {
                document.querySelectorAll(".product-popup-radio-js input.twenty-only").forEach((f)=>{
                    f.parentElement.classList.remove("hidden");
                });
                document.querySelectorAll(".product-popup-radio-js input").forEach((f)=>{
                    if (f.dataset.variant2Inventory <= 0 && f.dataset.variantInventory > 0 && f.classList.contains("filtered")) f.parentElement.removeAttribute("out-of-stock");
                    f.classList.remove("filtered");
                });
                document.querySelectorAll(".product-popup-radio-js input.ten-only").forEach((f)=>{
                    f.parentElement.classList.add("hidden");
                });
            }
        }
    });
};
const $a0586330b06ed090$var$initProductStrength = function() {
    const strengthWrapper = document.querySelector("." + $a0586330b06ed090$var$productOptionsCl.strengthWrapper);
    if (!strengthWrapper) return;
    const strengthRadios = [
        ...strengthWrapper.querySelectorAll("." + $a0586330b06ed090$var$productOptionsCl.strengthRadio)
    ];
    const quantityInput = document.querySelector("." + $a0586330b06ed090$var$productOptionsCl.quantityInput);
    $a0586330b06ed090$var$addStrengthEvents(strengthWrapper, strengthRadios, quantityInput);
};
function $a0586330b06ed090$export$2e2bcd8739ae039() {
    $a0586330b06ed090$var$initProductQuantity();
    $a0586330b06ed090$var$initProductPopup();
    $a0586330b06ed090$var$initProductStrength();
}


parcelRequire("e93Ww");
/**
 * Component: Accordion
 * ------------------------------------------------------------------------------
 * ARIA accessible accordion to show/hide content in a tabbed layout.
 *
 * @namespace accordion
 */ /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $acdc05c5163a1397$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $acdc05c5163a1397$export$2e2bcd8739ae039 = $acdc05c5163a1397$var$isObject;


/** Detect free variable `global` from Node.js. */ var $f516b7844ec12b2d$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $f516b7844ec12b2d$export$2e2bcd8739ae039 = $f516b7844ec12b2d$var$freeGlobal;


/** Detect free variable `self`. */ var $70d87f490d314e55$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $70d87f490d314e55$var$root = (0, $f516b7844ec12b2d$export$2e2bcd8739ae039) || $70d87f490d314e55$var$freeSelf || Function("return this")();
var $70d87f490d314e55$export$2e2bcd8739ae039 = $70d87f490d314e55$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $076958148d7b8c97$var$now = function() {
    return (0, $70d87f490d314e55$export$2e2bcd8739ae039).Date.now();
};
var $076958148d7b8c97$export$2e2bcd8739ae039 = $076958148d7b8c97$var$now;


/** Used to match a single whitespace character. */ var $938b3fb2c8835b92$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $938b3fb2c8835b92$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $938b3fb2c8835b92$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $938b3fb2c8835b92$export$2e2bcd8739ae039 = $938b3fb2c8835b92$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $944ef78c7936f824$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $944ef78c7936f824$var$baseTrim(string) {
    return string ? string.slice(0, (0, $938b3fb2c8835b92$export$2e2bcd8739ae039)(string) + 1).replace($944ef78c7936f824$var$reTrimStart, "") : string;
}
var $944ef78c7936f824$export$2e2bcd8739ae039 = $944ef78c7936f824$var$baseTrim;




/** Built-in value references. */ var $7231ea9a53162d12$var$Symbol = (0, $70d87f490d314e55$export$2e2bcd8739ae039).Symbol;
var $7231ea9a53162d12$export$2e2bcd8739ae039 = $7231ea9a53162d12$var$Symbol;



/** Used for built-in method references. */ var $d45ee1b4ca58b2c4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d45ee1b4ca58b2c4$var$hasOwnProperty = $d45ee1b4ca58b2c4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d45ee1b4ca58b2c4$var$nativeObjectToString = $d45ee1b4ca58b2c4$var$objectProto.toString;
/** Built-in value references. */ var $d45ee1b4ca58b2c4$var$symToStringTag = (0, $7231ea9a53162d12$export$2e2bcd8739ae039) ? (0, $7231ea9a53162d12$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d45ee1b4ca58b2c4$var$getRawTag(value) {
    var isOwn = $d45ee1b4ca58b2c4$var$hasOwnProperty.call(value, $d45ee1b4ca58b2c4$var$symToStringTag), tag = value[$d45ee1b4ca58b2c4$var$symToStringTag];
    try {
        value[$d45ee1b4ca58b2c4$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d45ee1b4ca58b2c4$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d45ee1b4ca58b2c4$var$symToStringTag] = tag;
        else delete value[$d45ee1b4ca58b2c4$var$symToStringTag];
    }
    return result;
}
var $d45ee1b4ca58b2c4$export$2e2bcd8739ae039 = $d45ee1b4ca58b2c4$var$getRawTag;


/** Used for built-in method references. */ var $d7c9274132d41268$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d7c9274132d41268$var$nativeObjectToString = $d7c9274132d41268$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d7c9274132d41268$var$objectToString(value) {
    return $d7c9274132d41268$var$nativeObjectToString.call(value);
}
var $d7c9274132d41268$export$2e2bcd8739ae039 = $d7c9274132d41268$var$objectToString;


/** `Object#toString` result references. */ var $10a1a04468b07e88$var$nullTag = "[object Null]", $10a1a04468b07e88$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $10a1a04468b07e88$var$symToStringTag = (0, $7231ea9a53162d12$export$2e2bcd8739ae039) ? (0, $7231ea9a53162d12$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $10a1a04468b07e88$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $10a1a04468b07e88$var$undefinedTag : $10a1a04468b07e88$var$nullTag;
    return $10a1a04468b07e88$var$symToStringTag && $10a1a04468b07e88$var$symToStringTag in Object(value) ? (0, $d45ee1b4ca58b2c4$export$2e2bcd8739ae039)(value) : (0, $d7c9274132d41268$export$2e2bcd8739ae039)(value);
}
var $10a1a04468b07e88$export$2e2bcd8739ae039 = $10a1a04468b07e88$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $aa1aa81ff5fe30da$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $aa1aa81ff5fe30da$export$2e2bcd8739ae039 = $aa1aa81ff5fe30da$var$isObjectLike;


/** `Object#toString` result references. */ var $dba9a50b57c13df5$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $dba9a50b57c13df5$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $aa1aa81ff5fe30da$export$2e2bcd8739ae039)(value) && (0, $10a1a04468b07e88$export$2e2bcd8739ae039)(value) == $dba9a50b57c13df5$var$symbolTag;
}
var $dba9a50b57c13df5$export$2e2bcd8739ae039 = $dba9a50b57c13df5$var$isSymbol;


/** Used as references for various `Number` constants. */ var $6c48dfe9f74903d4$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $6c48dfe9f74903d4$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6c48dfe9f74903d4$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6c48dfe9f74903d4$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6c48dfe9f74903d4$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6c48dfe9f74903d4$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $dba9a50b57c13df5$export$2e2bcd8739ae039)(value)) return $6c48dfe9f74903d4$var$NAN;
    if ((0, $acdc05c5163a1397$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $acdc05c5163a1397$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $944ef78c7936f824$export$2e2bcd8739ae039)(value);
    var isBinary = $6c48dfe9f74903d4$var$reIsBinary.test(value);
    return isBinary || $6c48dfe9f74903d4$var$reIsOctal.test(value) ? $6c48dfe9f74903d4$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6c48dfe9f74903d4$var$reIsBadHex.test(value) ? $6c48dfe9f74903d4$var$NAN : +value;
}
var $6c48dfe9f74903d4$export$2e2bcd8739ae039 = $6c48dfe9f74903d4$var$toNumber;


/** Error message constants. */ var $66225070125f262f$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $66225070125f262f$var$nativeMax = Math.max, $66225070125f262f$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $66225070125f262f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($66225070125f262f$var$FUNC_ERROR_TEXT);
    wait = (0, $6c48dfe9f74903d4$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $acdc05c5163a1397$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $66225070125f262f$var$nativeMax((0, $6c48dfe9f74903d4$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $66225070125f262f$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $076958148d7b8c97$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $076958148d7b8c97$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $076958148d7b8c97$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $66225070125f262f$export$2e2bcd8739ae039 = $66225070125f262f$var$debounce;


/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * - Used to provide consistency and keep DRY for our toggle classes.
 */ var $4da88745b4eecfc5$export$2e2bcd8739ae039 = {
    active: "is-active",
    adding: "is-adding",
    added: "is-added",
    collapsed: "is-collapsed",
    disabled: "is-disabled",
    focused: "is-focused",
    hidden: "is-hidden",
    loaded: "is-loaded",
    loading: "is-loading",
    locked: "is-locked",
    removing: "is-removing",
    sticky: "is-sticky",
    transitioning: "is-transitioning",
    headerClear: "site-header--transparent"
};


/**
 * Helper: Utils
 * ------------------------------------------------------------------------------
 * Karmoon utility functions.
 *
 * @namespace utils
 */ /**
 * Get unique objects from object literal.
 * @param {Object} object - Array/Object to remove duplicates from.
 * @returns {Object}
 */ function $54b4d535c8b4d410$export$7a5d5c156e7dc406(object) {
    return object.filter((value, index, self)=>self.indexOf(value) === index);
}
function $54b4d535c8b4d410$export$acaf96a27438246b(array1, array2) {
    return array1.concat(array2).filter((value, index, self)=>{
        return self.indexOf(value) === self.lastIndexOf(value);
    });
}
function $54b4d535c8b4d410$export$c72c4b7feb522769(defaults, properties) {
    // eslint-disable-next-line no-restricted-syntax
    for(const property in properties)if (properties != null && typeof properties !== "undefined") defaults[property] = properties[property];
    return defaults;
}
function $54b4d535c8b4d410$export$f312c3733b79ac0d(element) {
    return Array.prototype.filter.call(element.parentNode.children, (sibling)=>{
        return sibling !== element;
    });
}
function $54b4d535c8b4d410$export$dfdc1655ccc5b9cb(form) {
    const serialized = [];
    /**
     * Loop through each field in the form.
     */ // eslint-disable-next-line no-plusplus
    for(let i = 0; i < form.elements.length; i++){
        const field = form.elements[i];
        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") continue;
        /**
       * If a multi-select, get all selections.
       */ if (field.type === "select-multiple") // eslint-disable-next-line no-plusplus
        for(let counter = 0; counter < field.options.length; counter++){
            if (!field.options[counter].selected) continue;
            serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.options[counter].value)}`);
        }
        else if (field.type !== "checkbox" && field.type !== "radio" || field.checked) serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
    }
    return serialized.join("&");
}
function $54b4d535c8b4d410$export$af631764ddc44097(event, elem = window, callback, capture = false) {
    /**
     * If only a string is passed into the element parameter.
     */ if (typeof elem === "string") {
        document.querySelector(elem).addEventListener(event, callback, capture);
        return;
    }
    /**
     * If an element is not defined in parameters, then shift callback across.
     */ if (typeof elem === "function") {
        window.addEventListener(event, elem);
        return;
    }
    /**
     * Default listener.
     */ elem.addEventListener(event, callback, capture);
}
function $54b4d535c8b4d410$export$89e15fc796a4a429() {
    const { userAgent: userAgent } = window.navigator;
    // The order matters here, and this may report false positives for unlisted browsers.
    if (userAgent.indexOf("Firefox") > -1) // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
    return "Firefox";
    if (userAgent.indexOf("Opera") > -1) return "Opera";
    if (userAgent.indexOf("Trident") > -1) // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
    return "Internet Explorer";
    if (userAgent.indexOf("Edge") > -1) // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
    return "Edge";
    if (userAgent.indexOf("Chrome") > -1) // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
    return "Chrome";
    if (userAgent.indexOf("Safari") > -1) // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
    return "Safari";
    return "unknown";
}
function $54b4d535c8b4d410$export$61fc7d43ac8f84b0(callback, wait, immediate) {
    let timeout = null;
    return function(...args) {
        const later = function() {
            timeout = null;
            if (!immediate) callback.apply(this, args);
        };
        const callNow = immediate && !timeout;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(later, wait);
        if (callNow) callback.apply(this, args);
    };
}


/**
 * Mixin: Bind
 * -----------------------------------------------------------------------------
 * Mixin to set, remove and detect a class from a defined target.
 * - Useful to avoid multiple event binds when initialising components.
 *
 */ 
var /**
  * Create a new bind object.
  * @param {HTMLElement} element - HTML element to bind with a class.
  */ $3344b00a360931bc$export$2e2bcd8739ae039 = (element, config)=>{
    /**
    * Instance defaults settings.
    */ const defaults = {
        className: "post-init"
    };
    /**
    * Instance settings.
    */ const settings = (0, $54b4d535c8b4d410$export$c72c4b7feb522769)(defaults, config);
    /**
    * Set bind class on target.
    */ function set() {
        if (!element.length) {
            element.classList.add(settings.className);
            return;
        }
        [
            ...element
        ].forEach((item)=>{
            item.classList.add(settings.className);
        });
    }
    /**
    * Remove bind class on target.
    */ function remove() {
        if (!element.length) {
            element.classList.remove(settings.className);
            return;
        }
        [
            ...element
        ].forEach((item)=>{
            item.classList.remove(settings.className);
        });
    }
    /**
    * Check if element has already been initialised.
    */ function isSet() {
        if (!element.length) return element.classList.contains(settings.className);
        return [
            ...element
        ].every((item)=>{
            return item.classList.contains(settings.className);
        });
    }
    /**
    * Expose public interface.
    */ return Object.freeze({
        isSet: isSet,
        remove: remove,
        set: set
    });
};


/**
 * DOM selectors.
 */ const $d639514057d78f10$var$selectors = {
    control: '[js-accordion="control"]',
    item: '[js-accordion="item"]',
    content: '[js-accordion="content"]'
};
var /**
 * Export a new accordion instance.
 * @param {string} selector - The accordion item.
 * @param {object} config - Configuration.
 */ $d639514057d78f10$export$2e2bcd8739ae039 = (selector, config)=>{
    /**
   * Instance default settings.
   */ const defaults = {
        aria: true,
        singleOpen: true,
        showInitial: false,
        showAll: false,
        responsive: []
    };
    /**
   * Instance settings.
   */ const settings = (0, $54b4d535c8b4d410$export$c72c4b7feb522769)(defaults, config);
    /**
   * DOM node selectors.
   */ const nodeSelectors = {
        container: document.querySelector(selector),
        controls: [
            ...document.querySelector(selector).querySelectorAll($d639514057d78f10$var$selectors.control)
        ],
        items: [
            ...document.querySelector(selector).querySelectorAll($d639514057d78f10$var$selectors.item)
        ]
    };
    /**
   * Initialise component bind.
   */ const binder = (0, $3344b00a360931bc$export$2e2bcd8739ae039)(nodeSelectors.container);
    /**
   * Initialise component.
   */ function init() {
        if (binder.isSet()) return;
        if (settings.aria) setARIA();
        if (settings.showAll) showAllItems();
        if (settings.showInitial) showInitialItem();
        if (settings.responsive.length) setResponsiveEvents();
        setClickEvents();
        binder.set();
    }
    /**
   * Set click events on items.
   */ function setClickEvents() {
        nodeSelectors.controls.forEach((item)=>{
            (0, $54b4d535c8b4d410$export$af631764ddc44097)("click", item, (event)=>onItemClick(event, item.parentNode));
            lastNodeMargin(item.parentNode);
        });
    }
    /**
   * Handle toggle event on accordion control click.
   * @param {Event} event - Click event.
   * @param {HTMLElement} element - The accordion item.
   */ function onItemClick(event, element) {
        event.preventDefault();
        toggleElement(element);
    }
    function lastNodeMargin(container) {
        if (container.querySelector(".accordion__content").lastElementChild) {
            const lastChild = container.querySelector(".accordion__content").lastElementChild;
            lastChild.style.marginBottom = "0px";
        }
    }
    /**
   * Show targeted item and set ARIA values.
   * @param {HTMLElement} element - The accordion item.
   */ function showItem(element) {
        element.classList.add((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        const child = element.querySelector(".accordion__content");
        child.style.maxHeight = "10000px";
        child.classList.add((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        if (settings.aria) updateARIA(element, true);
    }
    /**
   * Hide targeted item and set ARIA values.
   * @param {HTMLElement} element - The accordion item.
   */ function hideItem(element) {
        const child = element.querySelector(".accordion__content");
        child.style.maxHeight = "0px";
        child.classList.remove((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        element.classList.remove((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        if (settings.aria) updateARIA(element, false);
    }
    /**
   * Check if item is active.
   * @param {HTMLElement} element - The accordion item.
   */ function isItemActive(element) {
        return element.classList.contains((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
    }
    /**
   * Hide all unselected items.
   * @param {HTMLElement} element - The accordion item.
   */ function hideUnselected(element) {
        nodeSelectors.items.forEach((item)=>{
            if (isItemActive(item) && item !== element) hideItem(item);
        });
    }
    /**
   * Show all items on init.
   */ function showAllItems() {
        nodeSelectors.items.forEach((element)=>{
            showItem(element);
        });
    }
    /**
   * Show initial item on init.
   */ function showInitialItem() {
        nodeSelectors.items.forEach((element, index)=>{
            if (index === 0) {
                showItem(element);
                return;
            }
            hideItem(element);
        });
    }
    /**
   * Hide all items.
   */ function hideAllItems() {
        nodeSelectors.items.forEach((item)=>{
            hideItem(item);
        });
    }
    /**
   * Toggle targeted item.
   * @param {HTMLElement} element - The accordion item.
   */ function toggleElement(element) {
        if (settings.singleOpen) hideUnselected(element);
        if (isItemActive(element)) {
            hideItem(element);
            return;
        }
        showItem(element);
    }
    /**
   * Create ARIA attributes.
   */ function setARIA() {
        nodeSelectors.container.setAttribute("role", "tablist");
        nodeSelectors.container.setAttribute("aria-label", "Accordion Control Group Buttons");
        nodeSelectors.items.forEach((item)=>{
            if (isItemActive(item)) {
                updateARIA(item, true);
                return;
            }
            updateARIA(item, false);
        });
    }
    /**
   * Update ARIA.
   * @param {HTMLElement} element - The accordion item.
   * @param {Boolean} value - Aria value.
   */ function updateARIA(element, value) {
        element.setAttribute("aria-selected", value);
        element.querySelector($d639514057d78f10$var$selectors.control).setAttribute("aria-expanded", value);
        element.querySelector($d639514057d78f10$var$selectors.content).setAttribute("aria-hidden", !value);
        if (!itemHasContentId(element)) updateARIAContentId(element);
    }
    /**
   * Check if ARIA control contains content id.
   * @param {HTMLElement} element - The accordion item.
   */ function itemHasContentId(element) {
        return element.querySelector($d639514057d78f10$var$selectors.control).hasAttribute("aria-controls");
    }
    /**
   * Update ARIA content id.
   * @param {HTMLElement} element - Click The accordion item.
   */ function updateARIAContentId(element) {
        const contentId = element.querySelector($d639514057d78f10$var$selectors.content).id;
        element.querySelector($d639514057d78f10$var$selectors.control).setAttribute("aria-controls", contentId);
    }
    /**
   * Set window resize events for responsive initialisation.
   */ function setResponsiveEvents() {
        handleResizeEvent();
        (0, $54b4d535c8b4d410$export$af631764ddc44097)("resize", (0, $66225070125f262f$export$2e2bcd8739ae039)(handleResizeEvent, 250));
    }
    /**
   * Handle resize events through debounce callback.
   * - Execute mobile callbacks.
   */ function handleResizeEvent() {
        settings.responsive.forEach((query)=>{
            if (window.matchMedia(`(min-width: ${query.breakpoint})`).matches) {
                reinit(query.settings);
                return;
            }
            reinit(settings);
        });
    }
    /**
   * Reinitialise component with options.
   * @param {Object} options - Options to use instead of defined settings.
   */ function reinit(options) {
        if (options.showAll) showAllItems();
        else hideAllItems();
    }
    /**
   * Expose public interface.
   */ return Object.freeze({
        init: init,
        hideAllItems: hideAllItems,
        showAllItems: showAllItems,
        showInitialItem: showInitialItem
    });
};


class $b8d422ffeb938bd1$var$NativeReviews extends HTMLElement {
    constructor(){
        super();
        this.addEventListener("click", ()=>{
            this.jumpToTrustpilot();
        });
    }
    jumpToTrustpilot() {
        document.querySelector(".accordion.accordion--product.accordion--product-reviews").scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        if (document.querySelector(".accordion--product-reviews") !== null) {
            (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-reviews", {}).init();
            (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-reviews").showInitialItem();
        }
    }
}
customElements.define("native-reviews", $b8d422ffeb938bd1$var$NativeReviews);


// countdown
(0, $50633e7301cb8da8$export$2e2bcd8739ae039)();
(0, $a0586330b06ed090$export$2e2bcd8739ae039)();
// swipers
(0, $d7be782da32a240e$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=product.js.map
